import AppLayout from '@/layouts/AppLayout.vue'
type User = {
  email: string
  lastName: string
  firstName: string
  status: string
  dob: string
  nationality: string
  sex: string
  account_id: string
}
const metaFactory = (auth: boolean, title: string, area: string, gate?: (user: User) => boolean) => ({
  auth,
  title,
  gate,
  area,
})
const lspRoutes = {
  name: 'LSP',
  path: '/long-stay-permit',
  component: AppLayout,
  meta: metaFactory(true, 'Long Stay Permit', 'long_stay_permit'),
  children: [
    {
      name: 'LSP-HOME',
      path: '',
      component: () => import('../pages/services/lsp/dashboard/Dashboard.vue'),
    },
    {
      name: 'LSP-FI',
      path: 'apply',
      component: () => import('../pages/services/lsp/application/CreateApplicationPage.vue'),
    },
    {
      name: 'LSP-TAC',
      path: 'terms-and-conditions',
      component: () => import('../pages/services/lsp/TermsAndConditionsPage.vue'),
    },
    {
      name: 'lsp-qualify',
      path: 'do-i-qualify',
      component: () => import('../pages/services/lsp/doIQualify/DoIQualifyPage.vue'),
    },
    {
      name: 'LSP-HTA',
      path: 'how-to-apply',
      component: () => import('../pages/services/lsp/HowToApplyPage.vue'),
    },
    {
      name: 'lsp-order-links',
      path: 'orders',
      redirect: { name: '' },
      children: [
        {
          name: 'lsp-orders',
          path: '',
          component: () => import('../pages/services/lsp/orders/LSPOrdersPage.vue'),
        },
        {
          name: 'lsp-order-details',
          path: ':id',
          component: () => import('../pages/services/lsp/orders/LSPOrderDetailPage.vue'),
        },
      ],
    },
    {
      name: 'LSP-APPLIST',
      path: 'applications',
      component: () => import('../pages/services/lsp/applications/ApplicationsPage.vue'),
    },
    {
      name: 'LSP-A',
      path: 'application',
      children: [
        {
          name: 'LSP-FA',
          path: ':id/form/:step',
          component: () => import('../pages/services/lsp/application/EditApplicationPage.vue'),
        },
        {
          name: 'LSP-AV',
          path: ':id/view',
          component: () => import('../pages/services/lsp/application/ViewApplicationPage.vue'),
        },
        {
          name: 'LSP-APB',
          path: ':id/payment',
          component: () => import('../pages/services/lsp/payments/PaymentBreakdown.vue'),
        },
        {
          name: 'LSP-APC',
          path: ':id/payment/:applicantId/checkout',
          component: () => import('../pages/services/lsp/checkout/Checkout.vue'),
        },
      ],
    },
  ],
}

export default lspRoutes
